export default {
  about: state => { return state.about },
  home: state => { return state.home },
  contact: state => { return state.contact }
}